export const formatStatus = (status: string): string => {
  switch (status) {
    case 'PENDING':
      return 'Awaiting Processing';
    case 'AWAITING_FULFILLMENT':
      return 'Awaiting Fulfillment';
    case 'FULFILLMENT_DELAY':
      return 'Fulfillment Delay';
    case 'AWAITING_DELIVERY':
      return 'Awaiting Delivery';
    case 'DELIVERED':
      return 'Received by Pharmacy';
    case 'CANCELLATION_REQUESTED':
      return 'Cancellation Requested';
    case 'CANCELLED':
      return 'Canceled';
    case 'PROCESSING_EXCEPTION':
      return 'Provider Clarification Needed';
    case 'ARCHIVED':
      return 'Archived';
    default:
      // Convert snake_case or camelCase to Title Case
      return status
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b\w/g, c => c.toUpperCase());
  }
};

export const formatDeliveryMethod = (method: string): string => {
  switch (method) {
    case 'pickup':
      return 'Pickup';
    case 'shipToPatient':
      return 'Ship To Patient';
    case 'shipToProvider':
      return 'Ship To Provider';
    default:
      // Convert camelCase to Title Case
      return method
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b\w/g, c => c.toUpperCase());
  }
};

export const getStatusColor = (status: string): 'warning' | 'success' | 'error' | 'default' => {
  switch (status) {
    case 'PENDING':
      return 'warning';
    case 'AWAITING_FULFILLMENT':
      return 'warning';
    case 'FULFILLMENT_DELAY':
      return 'error';
    case 'AWAITING_DELIVERY':
      return 'warning';
    case 'DELIVERED':
      return 'success';
    case 'CANCELLATION_REQUESTED':
      return 'warning';
    case 'CANCELLED':
      return 'error';
    case 'PROCESSING_EXCEPTION':
      return 'error';
    case 'ARCHIVED':
      return 'default';
    default:
      return 'default';
  }
};

// Available statuses for filtering (only the ones we want to show)
export const AVAILABLE_STATUSES = [
  'PENDING',
  'PROCESSING_EXCEPTION',
  'CANCELLATION_REQUESTED',
  'DELIVERED',
  'CANCELLED',
] as const;

// In-progress statuses only
export const IN_PROGRESS_STATUSES = [
  'PENDING',
  'PROCESSING_EXCEPTION',
  'CANCELLATION_REQUESTED'
] as const;